var Locales = /*#__PURE__*/function (Locales) {
  Locales["en"] = "en-us";
  Locales["de"] = "de";
  Locales["fr"] = "fr";
  Locales["es"] = "es";
  Locales["ja"] = "ja";
  Locales["it"] = "it";
  Locales["pt"] = "pt";
  return Locales;
}({});
var convertLocale = function convertLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  return Locales[locale] || Locales.en;
};

export { Locales, convertLocale };
